<div [innerHTML]="this.htmlText" class="isg-text-pane"></div>
